import React from "react";
import { Helmet } from "react-helmet";

import { TwoColumnLayout } from "../../../templates";
import { leftContent } from "./LoginForm";

const handleLogout = () => {
  window.location = "/logout";
};

const logoutButton = (
  <button
    type="button"
    onClick={handleLogout}
    className="px-4 py-2 hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-0 transition-all duration-200 cursor-pointer"
    style={{
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      background: "#FFF",
      boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
      fontSize: "14px",
      color: "#0A0A0A",
      lineHeight: "100%",
    }}
  >
    Log out
  </button>
);

export const RedirectionMessage = () => {
  return (
    <>
      <Helmet>
        <title>Sign in with Breathe</title>
      </Helmet>

      <TwoColumnLayout leftContent={leftContent} rightContentHeader={logoutButton}>
        <div className="flex flex-col items-center md:items-start w-full mb-0">
          <h1
            className="text-[30px] font-bold leading-[36px] login-text-foreground mb-0 font-rubik text-center md:text-left"
            style={{ fontWeight: 700, fontSize: "30px", lineHeight: "36px" }}
          >
            Sign in with Breathe
          </h1>
          <p className="login-text-muted text-sm mt-6 mb-6 font-rubik text-center md:text-left">
            Please hold on, we’re securely redirecting you to your destination...
          </p>
        </div>

        <div className="flex justify-center w-full">
          <div
            className="animate-spin rounded-full h-6 w-6"
            style={{
              border: "2px solid #0A0A0A",
              borderRightColor: "transparent",
            }}
            role="status"
            aria-label="Redirecting"
          />
        </div>
      </TwoColumnLayout>
    </>
  );
};
